module.exports = __webpack_public_path__ + "img/figure-3.3a30ddaa.png";